
import ParseDBFHeader from './ParseDBFHeader';

    const encoding = 'utf-8';


    const ParseDBF = (buffer) => {
        return new Promise(
            (resolve, reject) => {

              const records = []

              const headerResults = ParseDBFHeader(buffer).then( header => {

                  let sequenceNumber = 0;

                  let loc = header.start;
                  let bufLoc = header.start;
                  let overflow = null;
                  // this.paused = false;

                  // const stream = fs.createReadStream(this.filename);

                  /*this.readBuf = () => {

                      let buffer;
                      if (this.paused) {
                          this.emit('paused');
                          return;
                      }

                      while ((buffer = stream.read())) {
                          if (bufLoc !== header.start) { bufLoc = 0; }
                          if (overflow !== null) { buffer = overflow + buffer; }*/

                          while ((loc < (header.start + (header.numberOfRecords * header.recordLength))) && ((bufLoc + header.recordLength) <= buffer.length)) {
                            const record =  parseRecord(++sequenceNumber, buffer.slice(bufLoc, (bufLoc += header.recordLength)),header.fields);

                            if (!record['@deleted']){
                              records.push(record);
                            }
                          }

                          /*loc += bufLoc;
                          if (bufLoc < buffer.length) { overflow = buffer.slice(bufLoc, buffer.length); } else { overflow = null; }

                          return this;
                      }
                  };

*/
                  const fields = header.fields.map(item => item.name.replace(/[^A-Z]/g, ""));
                  // console.log('records',fields,records)

                  resolve({fields,records})
                  // stream.on('readable',this.readBuf);
                  // return stream.on('end', () => {
                  //     return this.emit('end');
                  // });
              });

              // return this;
            }
        )
    }

   /* const pause = () => {
        return this.paused = true;
    }

    const resume = () => {
        this.paused = false;
        this.emit('resuming');
        return (this.readBuf)();
    }*/

    const parseRecord = (sequenceNumber, buffer, fields) => {
        const record = {
            '@sequenceNumber': sequenceNumber,
            '@deleted': [42,'*'].includes((buffer.slice(0, 1))[0])
        };

        let loc = 1;
        for (let field of Array.from(fields)) {
            (field => {
              // console.log('field',field.name,field.name.length,field.name.replace(/[^a-zA-Z]/g, ""),field.name.replace(/[^a-zA-Z]/g, "").length)
                return record[field.name.replace(/[^A-Z]/g, "")] = parseField(field, buffer.slice(loc, (loc += field.length)));
            })(field);
        }

        return record;
    }

    const parseField = (field, buffer) => {
        let value = (buffer.toString(encoding)).trim();

        if (field.type === 'C') { // Character
            value = value;
        } else if (field.type === 'F') { // Floating Point
            value = (value === +value) && (value === (value | 0)) ? parseInt(value, 10) : parseFloat(value, 10);
        } else if (field.type == 'L') { // Logical
            switch (value) {
                case (['Y', 'y', 'T', 't'].includes(value)):
                    value = true;
                    break;
                case (['N', 'n', 'F', 'f'].includes(value)):
                    value = false;
                    break;
                default:
                    value = null;
            }
        } else if (field.type === 'M') { // Memo
            value = value;
        } else if (field.type === 'N') { // Numeric
            value = value === +value && value === (value|0) ? parseInt(value) : parseFloat(value, 10);
        }

        return value;
    }

export default ParseDBF;